module.exports = __webpack_public_path__ + "img/v6.a72a667e.png";